import React from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import { PageHeader } from '@insurancemenu/imenu-components-lib';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import AdditionalOutputsContent from '../../components/additional-outputs/AdditionalOutputsContent/index';
import { createStyles } from '../../globalStyles';
import { ContentWrapperStyled, DateStyled } from './styles';

const AdditionalOutputsPage: React.FC = observer(() => {
  const {
    additionalOutputsStore: { creationDate, loading },
  } = useRootStore();

  const classes = createStyles();
  const history = useHistory();

  const onBackButtonClick = (): void => {
    history.goBack();
  };

  const showCreationDate = !loading && creationDate;

  return (
    <ProposalStatusLayout>
      <div className={classes.pageWrapper}>
        <PageHeader
          title="Member ID Cards"
          spacing={showCreationDate ? 'withActionsBelowCompact' : 'default'}
          onBackButtonClick={onBackButtonClick}
        />
        {showCreationDate && <DateStyled>{`Generated on: ${normDateToShortAmericanDate(creationDate)}`}</DateStyled>}
        <ContentWrapperStyled>
          <AdditionalOutputsContent />
        </ContentWrapperStyled>
      </div>
    </ProposalStatusLayout>
  );
});

export default AdditionalOutputsPage;
